import { c as _c } from "react/compiler-runtime";
import { Button, IconButton, Stack } from '@mui/material';
export const VXButtons = t0 => {
  const $ = _c(15);
  const {
    onApprove,
    onCancel,
    approveDisabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: "8px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onApprove) {
    t2 = () => {
      onApprove();
    };
    $[1] = onApprove;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <i className="material-symbols-check w-[20px] h-[20px]" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== approveDisabled || $[5] !== t2) {
    t4 = <Button data-testid="v-btn" disabled={approveDisabled} onClick={t2} variant="contained" className="min-w-[20px]! p-[6px]">{t3}</Button>;
    $[4] = approveDisabled;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onCancel) {
    t5 = () => {
      onCancel();
    };
    $[7] = onCancel;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <i className="material-symbols-close-rounded w-[20px] h-[20px] text-(--mui-palette-text-primary)" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <IconButton data-testid="x-btn" onClick={t5}>{t6}</IconButton>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <Stack direction="row" sx={t1}>{t4}{t7}</Stack>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};